/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Label_LowerInputs */

const en_us2_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower`)
};

const pt_br2_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferior`)
};

const es_419_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferior`)
};

const pt_pt2_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferior`)
};

const fr_fr2_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas`)
};

const de_de2_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterkörper`)
};

const it_it2_plan_label_lower = /** @type {(inputs: Plan_Label_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferiore`)
};

/**
* | output |
* | --- |
* | "Lower" |
*
* @param {Plan_Label_LowerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_label_lower = /** @type {((inputs?: Plan_Label_LowerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Label_LowerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_label_lower(inputs)
	if (locale === "es-419") return es_419_plan_label_lower(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_label_lower(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_label_lower(inputs)
	if (locale === "de-DE") return de_de2_plan_label_lower(inputs)
	if (locale === "it-IT") return it_it2_plan_label_lower(inputs)
	return en_us2_plan_label_lower(inputs)
});
export { plan_label_lower as "plan.label_lower" }